export const LOCAL_API_URL = 'https://localhost:7107/api';
export const ONLINE_API_URL_HTTPS = 'https://micgatway.micgreen.com/api';
export const ONLINE_API_URL_HTTP = 'http://micgatway.micgreen.com/api';
export const ONLINE_API_URL = ONLINE_API_URL_HTTPS; // Default to HTTPS

// API Gateway Configuration
const getApiBaseUrl = () => {
  // Check environment variable first
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Check if running in browser environment
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // For local development
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      console.log('🔧 Development mode on localhost - using local API');
      return LOCAL_API_URL;
    }
  }
  
  // Default: production gateway
  console.log(`🔧 Using production API_BASE_URL: ${ONLINE_API_URL}`);
  return ONLINE_API_URL;
};

export let API_BASE_URL = getApiBaseUrl();

// Helper to update API URL dynamically (e.g. if local is down)
export const setApiBaseUrl = (url: string) => {
  console.log(`🔄 Switching API_BASE_URL to: ${url}`);
  API_BASE_URL = url;
};
// Service Endpoints
export const ENDPOINTS = {
  // Authentication
  LOGIN: '/identity/login',
  REGISTER: '/identity/register',
  REFRESH_TOKEN: '/identity/refresh-token',
  
  // Store Services
  STORES: '/store',
  STORE_ITEMS: (storeId: number) => `/store/${storeId}/items`,
  ADD_STORE_ITEM: (storeId: number) => `/store/${storeId}/items`,
  STORE_CUSTOMERS: (storeId: number) => `/store/${storeId}/customers`,
  STORE_PRODUCT_REQUESTS: (storeId: number) => `/store/${storeId}/product-requests`,
  CREATE_PRODUCT_REQUEST: (storeId: number) => `/store/${storeId}/product-requests`,
  CREATE_CART_REQUEST: (storeId: number) => `/store/${storeId}/cart-requests`,
  GET_CART_REQUESTS: '/store/cart-requestsForCustomer',
  
  // Lookup Services
  ITEMS: '/lookup/items',
  ADD_ITEM: '/lookup/AddItems',
  CURRENCIES: '/lookup/currencies',
  CURRENCY_RATES: '/lookup/currency-rate-masters',
  COUNTRIES: '/lookup/countries',
  STORE_PAYMENT_METHODS: '/lookup/store-payment-methods',
  STORE_SHIPPING_METHODS: '/lookup/store-shipping-methods',
  SHIPPING_PREVIEW: '/Cart/shipping-preview',
  
  // Category Services
  CATEGORIES: '/category',
  ADD_CATEGORY: '/category',
  
  // Customer Services
  CUSTOMERS: '/customers',
};

// Default Store ID (can be changed based on URL or selection)
export const DEFAULT_STORE_ID = 1;

